import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

import { styles } from './styles';

import type { ReactNode } from 'react';

interface IShellProps {
  // The hiring company, never Scout or :Recruit.
  companyName: string;
  year: number;
  children: ReactNode;
}

// Page chrome forked from the candidate portal pack (PortalShell, the header's
// company-name row and PortalFooter). Host code can't import pack internals,
// and the real footer reads the clock for its year, where this page takes the
// server time it was rendered with.
const BookingShell = ({ companyName, year, children }: IShellProps) => (
  <Box sx={styles.page}>
    <Box component="header" sx={styles.header}>
      <Typography noWrap component="p" sx={styles.companyName}>
        {companyName}
      </Typography>
    </Box>
    <Box component="main" sx={styles.main}>
      {children}
    </Box>
    <Box component="footer" sx={styles.footer}>
      <Stack sx={styles.footerLinks}>
        <Typography sx={styles.footerText}>{`© ${year} Scout Talent`}</Typography>
        <Typography component="a" href="/privacy_policy" sx={styles.footerLink}>
          Privacy Policy
        </Typography>
        <Typography component="a" href="/terms" sx={styles.footerLink}>
          Terms and Conditions
        </Typography>
      </Stack>
      <Typography sx={styles.footerText}>Powered by Scout Talent</Typography>
    </Box>
  </Box>
);

interface ITitleProps {
  title: string;
  subtitle: string;
  centred?: boolean;
}

export const PageTitle = ({ title, subtitle, centred = false }: ITitleProps) => (
  <Stack sx={centred ? [styles.titleBlock, styles.centredTitleBlock] : styles.titleBlock}>
    <Typography component="h1" sx={styles.title}>
      {title}
    </Typography>
    <Typography sx={styles.subtitle}>{subtitle}</Typography>
  </Stack>
);

export default BookingShell;
